export default {
    parts: ['container', 'icon', 'text'],
    baseStyle: {
        container: {
            alignItems: 'center',
            justifyContent: 'flex-start',
            marginBottom: 2
        },
        icon: {
            width: '13px',
            height: '13px'
        },
        text: {
            color: 'webTypo.textError',
            textStyle: 'bodyXsRegular',
            marginTop: 0,
            marginLeft: 1
        }
    }
}
